export const statisticsPath = 'statistics'

const displayName = 'Статистика'

export default {
    name: 'statistics',
    display: displayName,
    path: statisticsPath,
    meta: {
        layout: 'main',
        requiresAuth: true,
        title: displayName,
        permission: ['ROLE_ADMIN', 'ROLE_ROOT_ADMIN'],
    },
    component: () => import("@/views/ProfileTab/components/Statistics")
}
